/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateCompanyResponse model module.
* @module model/CreateCompanyResponse
* @version 2020-12-7
*/
export default class CreateCompanyResponse {
    /**
    * Constructs a new <code>CreateCompanyResponse</code>.
    * 会社登録レスポンス
    * @alias module:model/CreateCompanyResponse
    * @class
    * @param id {Number} 会社ID
    * @param updatedAt {Number} 更新時刻
    * @param result {module:model/CreateCompanyResponse.ResultEnum} 
    */

    constructor(id, updatedAt, result) {
        
        
        this['id'] = id;
        this['updatedAt'] = updatedAt;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>CreateCompanyResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateCompanyResponse} obj Optional instance to populate.
    * @return {module:model/CreateCompanyResponse} The populated <code>CreateCompanyResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateCompanyResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * 会社ID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * 更新時刻
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;
    /**
    * @member {module:model/CreateCompanyResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
